module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events overflow-y-auto"
  }, [_c('filters'), _vm._v(" "), _c('more')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-68238521", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68238521"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Events.vue
// module id = 1690
// module chunks = 0